import { AchievementsModel } from "./achievements-model";

export class NextAchievementStepModel {
    lastAchieved!: AchievementsModel;
    nextAchievement!: AchievementsModel;
    remainingAchievementBooks!: number;
    lastAchievedStep!: number;
    nextAchievementStep!: number;
    readBooksCount!: number;
}